// application/useCases/commitAuthorizations.js
/**
 * Flushes an authorization unit of work.
 *
 * The client id is stamped HERE rather than at staging, which is what lets a letter be recorded for
 * a client that does not exist yet.
 *
 * `clinicId` IS THE CLIENT'S CLINIC, not the writer's, and the caller is responsible for that. They
 * differ when a role-less user linked through `usersClients` reaches a client in another clinic, and
 * stamping the writer's would orphan the record — every read scopes by clinic, so it would be
 * invisible to the clinic that owns the client. The legacy `clientAuthorizations` collection has
 * exactly that bug. The Firestore rules validate this independently.
 *
 * ONE OPERATION, ALL OR NOTHING — the port states why.
 *
 * @param {import('../authorizationUnitOfWork').AuthorizationUnitOfWork} unitOfWork
 * @param {{ clientId: string, clinicId: string }} scope
 * @param {import('../ports/AuthorizationRepository.port').AuthorizationRepository} repository
 * @returns {Promise<void>}
 */
// eslint-disable-next-line import/prefer-default-export
export async function commitAuthorizations(unitOfWork, { clientId, clinicId }, repository) {
  const changes = unitOfWork.changes();

  if (changes.length === 0) {
    return;
  }

  await repository.applyChanges(changes.map(({ intent, authorization }) => ({
    intent,
    authorization: { ...authorization, clientId, clinicId },
  })));

  unitOfWork.markCommitted();
} // commitAuthorizations()
